import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import { userLogout, forbiddenAccess } from './auth';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        userLogout();
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });

export function updateStaffMappingStart() {
  return {
    type: types.UPDATE_STAFF_MAPPING_START,
  };
}

export function updateStaffMappingSuccess() {
  return {
    type: types.UPDATE_STAFF_MAPPING_SUCCESS,
  };
}

export function updateStaffMappingFail(ex) {
  return {
    type: types.UPDATE_STAFF_MAPPING_FAIL,
    error: ex.message,
  };
}

export function updateStaffMapping(data) {
  return (dispatch, getState) => {
    dispatch(updateStaffMappingStart());
    const { business, auth } = getState();
    const payload = {
      client_id: auth.userid,
      staff_mapping: data,
    };
    request
      .post(
        `${window.Config.API_URL}/business/dental/internal/preferences/staff_mapping`,
      )
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(payload)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(updateStaffMappingSuccess(resp));
        } else {
          dispatch(updateStaffMappingFail());
        }
      })
      .catch((ex) => {
        console.error('Staff mapping update failed:', ex);
        dispatch(updateStaffMappingFail(ex));
      });
  };
}
